import React, { Component } from "react";
import { Modal, Form, Col, Button, Card, Container, Row, Table } from "react-bootstrap";
import moment from "moment";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withApollo } from "react-apollo";
import Select from "react-select";
import axios, { post } from "axios";
import '../institute_revision_material/_instRevisionMaterial.scss'

const ADD_REVISION_MATERIAL = gql`
  mutation($params: RevisionMaterial) {
    addRevisionMaterial(params: $params)
  }`

class RevisionMaterialUploadModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            branchError: "",
            class_id: "",
            classError: "",
            exam_id: "",
            examError: "",
            subject_id: "",
            subjectError: "",
            chapter_id: "",
            chapterError: "",
            title: "",
            titleError: "",
            file_uploading: "",
            fileError: "",
            getExams: [],
            getClasses: [],
            getSubjects: [],
            empWiseSubjects: [],
            chapters: [],
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            dataClear: 0,
            isDisabled: false,
            isSubmitting: false,
            existingmaterialId: ""
        }
    }



    getExams = (branch_id) => {
        let getArray = [];

        let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branch_id).map((item1) => item1.exam_id))].sort();

        uniqueExams.map((val) => {
            let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
            const newObj = {
                value: individualExamData.id,
                label: individualExamData.exam
            }
            getArray.push(newObj);
        })
        return getArray
    }

    getClasses = (branch_id, exam_id) => {
        let getArray = [];

        let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branch_id && item.exam_id == exam_id).map((item1) => item1.class_id))].sort();

        uniqueClasses.map((val) => {
            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
            const newObj = {
                value: individualClassData.id,
                label: individualClassData.class
            }
            getArray.push(newObj);
        })
        return getArray
    }

    getSubjects = (exam_id) => {
        let examWiseSubjects = [{ value: 0, label: "General" }];
        let employeesdata = this.props.getEmployees.filter((item) => item.employee_id == Cookies.get("id"))
        if (Cookies.get("userlevel") == 3 && employeesdata.length > 0) {
            console.log("sub");
            let subjectIdsArray = employeesdata[0].subject_ids.split(",")

            subjectIdsArray.forEach(subjectId => {

                const foundSubject = this.props.globals.offlineExamSubjects.filter(item2 => item2.id === +subjectId);
                if (foundSubject) {
                    foundSubject.map((item) => {
                        const newObj = {
                            value: item.id,
                            label: item.subject
                        };
                        examWiseSubjects.push(newObj);
                    })
                }
            });
        } else {
            console.log("non sub");
            if (this.props.globals.offlineExamSubjects.length > 0) {
                this.props.globals.exams.filter((item) => item.id == exam_id)[0].exam_subjects.map((item1) => {
                    this.props.globals.offlineExamSubjects.map((item2) => {
                        if (item1.subject_id == item2.id) {
                            const newObj = {
                                value: item2.id,
                                label: item2.subject
                            }
                            examWiseSubjects.push(newObj);

                        }
                    })
                })
            }
        }
        return examWiseSubjects;
    }


    handleInputChange = e => {

        const name = e.target.name;
        const value = e.target.value;
        if (name == "branch") {
            if (value != "0") {
                this.setState({
                    branch_id: value,
                    branchError: "",
                    class_id: "",
                    classError: "",
                    exam_id: "",
                    examError: "",
                    subject_id: "",
                    subjectError: "",
                    chapter_id: "",
                    chapterError: "",
                    title: "",
                    titleError: "",
                    file_uploading: "",
                    fileError: "",
                    getExams: this.getExams(value),
                    getClasses: [],
                    getSubjects: [],
                    chapters: []
                })
            } else {
                this.setState({
                    branch_id: "",
                    branchError: "",
                    class_id: "",
                    classError: "",
                    exam_id: "",
                    examError: "",
                    subject_id: "",
                    subjectError: "",
                    chapter_id: "",
                    chapterError: "",
                    title: "",
                    titleError: "",
                    file_uploading: "",
                    fileError: "",
                    getExams: [],
                    getClasses: [],
                    getSubjects: [],
                    chapters: []
                })
            }
        }

        if (name == "exam") {

            if (value != "0") {
                this.setState({
                    exam_id: value,
                    examError: "",
                    class_id: "",
                    classError: "",
                    subject_id: "",
                    subjectError: "",
                    chapter_id: "",
                    chapterError: "",
                    title: "",
                    titleError: "",
                    file_uploading: "",
                    fileError: "",
                    getClasses: this.getClasses(this.state.branch_id, value),
                    getSubjects: [],
                    chapters: []
                })

            } else {
                this.setState({
                    exam_id: "",
                    examError: "",
                    class_id: "",
                    classError: "",
                    subject_id: "",
                    subjectError: "",
                    chapter_id: "",
                    chapterError: "",
                    title: "",
                    titleError: "",
                    file_uploading: "",
                    fileError: "",
                    getClasses: [],
                    getSubjects: [],
                    chapters: []
                })

            }
        }
        if (name == "class") {

            if (value != "0" && value != "--Select Class--") {
                this.setState({
                    class_id: value,
                    classError: "",
                    subject_id: "",
                    subjectError: "",
                    chapter_id: "",
                    chapterError: "",
                    title: "",
                    titleError: "",
                    file_uploading: "",
                    fileError: "",
                    getSubjects: this.getSubjects(this.state.exam_id),
                    chapters: []
                })


            } else {

                this.setState({
                    class_id: value,
                    classError: "",
                    subject_id: "",
                    subjectError: "",
                    chapter_id: "",
                    chapterError: "",
                    title: "",
                    titleError: "",
                    file_uploading: "",
                    fileError: "",
                    getSubjects: [],
                    chapters: []
                })

            }
        }
        if (name == "subject") {
            if (value != "" && value != "--Select Subject--") {
                if (value != "0") {
                    let subjectWiseChapters = []

                    if (this.state.exam_id == "1" || this.state.exam_id == "2") {
                        subjectWiseChapters = this.props.globals.subjects.filter((a) => a.id == value)[0].chapters.filter((a) => a.class == this.state.class_id)
                    } else {
                        subjectWiseChapters = this.props.globals.subjects.filter((a) => a.id == value)[0].state_chapters.filter((a) => a.class == parseInt(this.state.class_id) && a.exam_id == parseInt(this.state.exam_id))
                    }


                    console.log("subjectWiseChapters", subjectWiseChapters);
                    let chapters = []
                    const obj = {
                        value: 0,
                        label: "Select...",
                    }
                    chapters.push(obj)
                    subjectWiseChapters.map((item) => {
                        const newObj = {
                            value: item.id,
                            label: item.chapter
                        }
                        chapters.push(newObj)
                    })
                    this.setState({
                        subject_id: value,
                        subjectError: "",
                        chapters: chapters,
                        chapter_id: "",
                        chapterError: "",
                        title: "",
                        titleError: "",
                        file_uploading: "",
                        fileError: "",
                    })
                } else {
                    this.setState({
                        subject_id: value
                    })
                }
            } else {
                this.setState({
                    subject_id: "",
                    subjectError: "",
                    chapters: [],
                    chapter_id: "",
                    chapterError: "",
                    title: "",
                    titleError: "",
                    file_uploading: "",
                    fileError: "",
                })
            }
        }

        if (name == "title") {
            this.setState({
                title: value,
                titleError: "",
                file_uploading: "",
                fileError: "",
            })
        }

        if (name == "file_uploading") {
            const formData = new FormData();
            console.log("formDataBefore", formData.append);
            formData.append('file', e.target.files[0]);
            console.log("formData", e.target.files[0], formData);

            axios.post('https://rizee.in/pdfFiles.php?instituteRevisionMaterials=true', formData)
                .then((response) => {
                    console.log("response1", response);
                    this.setState({ file_uploading: response.data.filename });
                })
                .catch((error) => {
                    this.setState({ error: 'An error occurred while uploading the file.' });
                });
            this.setState({
                file_uploading: value,
                fileError: "",
            })
        }
    };

    chapterhandleChange = (e) => {
        console.log("ee", e)
        if (e.value != "") {
            this.setState({
                chapter_id: e.value,
                chapterError: "",
                title: "",
                titleError: "",
                file_uploading: "",
                fileError: "",
            })
        } else {
            this.setState({
                chapter_id: "",
                chapterError: "",
                title: "",
                titleError: "",
                file_uploading: "",
                fileError: "",

            })
        }
    }


    handleFormSubmit = () => {

        if (this.state.branch_id === "" || this.state.branch_id === "--Select Branch--") {
            this.setState({ branchError: " Please select branch " });
            return ""
        }
        if (this.state.exam_id === "" || this.state.exam_id === "--Select Exam--") {
            this.setState({ examError: "Please Select exam" });
            return ""
        }
        if (this.state.class_id === "" || this.state.class_id === "--Select Class--") {
            this.setState({ classError: " Please select class " });
            return ""
        }
        if (this.state.subject_id === "" || this.state.subject_id === "--Select Subject--") {
            this.setState({ subjectError: " Please select Subject " });
            return ""
        }
        if (this.state.subject_id == "0") {
            this.setState({ chapterError: "" });
        } else if (this.state.chapter_id === "" || this.state.subject === "Select...") {
            this.setState({ chapterError: "Please select Chapter" });
            return ""
        }
        if (this.state.title == "") {
            this.setState({ titleError: "  Please Enter Title " })
            return ""
        }
        if (this.props.stateData?.individualMaterials?.length > 0) {
            if (this.state.file_uploading == "") {
                this.setState({ fileError: "" })
            }
        } else {
            if (this.state.file_uploading == "") {
                this.setState({ fileError: "  Please choose file " })
                return ""
            }
        }
        this.setState({ isSubmitting: true })

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch_id),
            exam_id: parseInt(this.state.exam_id),
            class_id: parseInt(this.state.class_id),
            subject_id: parseInt(this.state.subject_id),
            chapter_id: this.state.chapter_id != "" && this.state.chapter_id != undefined ? parseInt(this.state.chapter_id) : null,
            file_name: this.state.title.toString(),
            file_path: this.state.file_uploading == "" || this.state.file_uploading == undefined ? "" : `https://rizee.in/educational_mngt/institute_revision_materials/${this.state.file_uploading}`,
            inserted_by: parseInt(Cookies.get("id")),
            existing_revisionMaterialId: this.state.existingmaterialId != "" && this.state.existingmaterialId != undefined ? this.state.existingmaterialId : null
        }
        this.setState({ loadingSpinner: 1 })

        console.log("params", params);

        this.addRevisionMaterial(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0 });
        })

    };

    addRevisionMaterial = async (
        params) => {
        await this.props.addRevisionMaterial({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addRevisionMaterial) {
                    this.setState({
                        currentStep: 5,
                        loadingSpinner: 0,
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1000)
                }
            }

        });
    };
    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            console.log("update");
            this.setState({
                dataClear: 1,
                branch_id: "",
                branchError: "",
                class_id: "",
                classError: "",
                exam_id: "",
                examError: "",
                subject_id: "",
                subjectError: "",
                chapter_id: "",
                chapterError: "",
                title: "",
                titleError: "",
                file_uploading: "",
                fileError: "",
                getExams: [],
                getClasses: [],
                getSubjects: [],
                empWiseSubjects: [],
                chapters: [],
                loadingSpinner: 0,
                currentStep: 1,
                isSubmitting: false
            })

            let existingMaterialDetails = this.props.stateData.individualMaterials
            console.log("existingMaterialDetails", existingMaterialDetails);
            if (existingMaterialDetails.length > 0) {
                let subjectWiseChapters = []
                let chapters = []
                if (existingMaterialDetails[0].chapter_id != "0") {

                    if (existingMaterialDetails[0].exam_id == "1" || existingMaterialDetails[0].exam_id == "2") {
                        subjectWiseChapters = this.props.globals.subjects.filter((a) => a.id == existingMaterialDetails[0].subject_id)[0].chapters.filter((a) => existingMaterialDetails[0].class_id == a.class)
                    } else {
                        subjectWiseChapters = this.props.globals.subjects.filter((a) => a.id == existingMaterialDetails[0].subject_id)[0].state_chapters.filter((a) => parseInt(existingMaterialDetails[0].class_id) == a.class && existingMaterialDetails[0].exam_id == a.exam_id)
                    }


                    console.log("subjectWiseChapters", subjectWiseChapters);

                    const obj = {
                        value: 0,
                        label: "Select...",
                    }
                    chapters.push(obj)
                    subjectWiseChapters.map((item) => {
                        const newObj = {
                            value: item.id,
                            label: item.chapter
                        }
                        chapters.push(newObj)
                    })
                }
                this.setState({
                    branch_id: existingMaterialDetails[0].branch_id,
                    getExams: this.getExams(existingMaterialDetails[0].branch_id),
                    exam_id: existingMaterialDetails[0].exam_id,
                    getClasses: this.getClasses(existingMaterialDetails[0].branch_id, existingMaterialDetails[0].exam_id),
                    class_id: existingMaterialDetails[0].class_id,
                    getSubjects: this.getSubjects(existingMaterialDetails[0].exam_id),
                    subject_id: existingMaterialDetails[0].subject_id,
                    chapters: chapters,
                    chapter_id: existingMaterialDetails[0].chapter_id,
                    title: existingMaterialDetails[0].file_name,
                    file_uploading: existingMaterialDetails[0].file_path,
                    isDisabled: true,
                    existingmaterialId: existingMaterialDetails[0].id
                })
            } else {
                this.setState({
                    branch_id: "",
                    exam_id: "",
                    class_id: "",
                    subject_id: "",
                    chapters: [],
                    getExams: [],
                    getClasses: [],
                    getSubjects: [],
                    chapter_id: "",
                    title: "",
                    file_uploading: "",
                    isDisabled: false
                })
            }
        }

        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }

    }
    render() {
        console.log("uppp", this.state);
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Upload Materials</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                            <Form>
                                <Form.Row>
                                    {/* BRANCH */}
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="font-weight-bold">Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch_id} disabled={this.state.isDisabled}>
                                            <option >--Select Branch--</option>
                                            {(() => {
                                                let branchData = [];
                                                if (Cookies.get("userlevel") == 3) {
                                                    branchData = this.props.globals.globalBranches.filter((item) => item.id == Cookies.get("branch_id"));
                                                } else {
                                                    branchData = this.props.globals.globalBranches;
                                                }
                                                return branchData.map((branchdata) => (
                                                    <option
                                                        key={branchdata.id}
                                                        value={branchdata.id}
                                                        selected={this.state.branch_id == branchdata.id ? true : false}
                                                    >
                                                        {branchdata.branch_name}
                                                    </option>
                                                ));
                                            })()}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>
                                    {/* EXAM */}
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectExam">
                                        <Form.Label className="font-weight-bold">Exam</Form.Label>
                                        <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam_id} disabled={this.state.isDisabled}>
                                            <option>--Select Exam--</option>
                                            {this.state.getExams.map(item => (
                                                <option key={item.value} value={item.value} selected={this.state.exam_id == item.value ? true : false} >
                                                    {item.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.examError}
                                        </Form.Text>
                                    </Form.Group>
                                    {/* CLASS */}
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                                        <Form.Label className="font-weight-bold">Class</Form.Label>
                                        <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class_id} disabled={this.state.isDisabled}>
                                            <option>--Select Class--</option>
                                            {this.state.getClasses.map(classdata => (
                                                <option key={classdata.value} value={classdata.value} selected={this.state.class_id == classdata.value ? true : false}  >
                                                    {classdata.label}
                                                </option>
                                            ))}

                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.classError}
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectTitle">
                                        <Form.Label className="font-weight-bold">Subject</Form.Label>
                                        <Form.Control as="select" name="subject" onChange={this.handleInputChange} value={this.state.subject_id} disabled={this.state.isDisabled} >
                                            <option>--Select Subject--</option>
                                            {this.state.getSubjects.map(subject => (
                                                <option key={subject.value} value={subject.value} selected={this.state.subject_id == subject.value ? true : false} >
                                                    {subject.label}
                                                </option>
                                            ))}

                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.subjectError}
                                        </Form.Text>
                                    </Form.Group>
                                </Form.Row>

                                <Form.Row>
                                    {
                                        this.state.subject_id != "0" ? (
                                            <Form.Group as={Col} lg={4} md={12} sm={12} controlId="SelectChapter">
                                                <Form.Label className="font-weight-bold">Chapter</Form.Label>
                                                <div style={{ width: "242px" }}>
                                                    <Select
                                                        options={this.state.chapters}
                                                        onChange={(e) => this.chapterhandleChange(e)}
                                                        name="chapter"
                                                        isDisabled={this.props.stateData.individualMaterials.length > 0 ? true : false}
                                                        value={this.state.chapters.length > 0 ? this.state.chapters.find(chapter => chapter.value == this.state.chapter_id) : ""}
                                                    />
                                                </div>
                                                <Form.Text className="form-text text-danger">
                                                    {this.state.chapterError}
                                                </Form.Text>
                                            </Form.Group>
                                        ) : ""
                                    }

                                    <Form.Group as={Col} lg={4} md={12} sm={12}>
                                        <div>
                                            <div className='font-weight-bold'><label>Enter Title</label></div>
                                            <input type='text' className='form-control' placeholder="Enter Title" name="title" value={this.state?.title} onChange={this.handleInputChange} />
                                        </div>
                                        <Form.Text className="form-text text-danger">
                                            {this.state.titleError}
                                        </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="selectFile">
                                        <Form.Label className="font-weight-bold">Upload File</Form.Label>
                                        <div className="form-control">
                                            <Form.Control type="file" name="file_uploading" id="file" accept=".pdf" onChange={this.handleInputChange} />
                                        </div>
                                        <Form.Text className="form-text text-danger">
                                            {this.state.fileError}
                                        </Form.Text>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer variant="white" >
                    <Row>
                        <Col sm={12}>
                            {this.state.currentStep == 5 ? (
                                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                    <p style={{ color: "green" }}>successfully Uploaded</p>
                                </Form.Text>
                            ) : (
                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                    {this.state.submitError}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                            <button type="button" className='revision_materials_btn text-uppercase' disabled={this.state.isSubmitting} style={this.state.isSubmitting == true ? { cursor: "not-allowed" } : { cursor: "pointer" }} onClick={this.handleFormSubmit}>
                                {
                                    this.state.loadingSpinner == 1 ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : ""
                                }Upload</button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }
}
export default withRouter(withApollo(
    graphql(ADD_REVISION_MATERIAL, {
        name: "addRevisionMaterial"
    })
        (RevisionMaterialUploadModal)));